import React from 'react';
import { Car, Footprints, TreePine, AlertTriangle, Check } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/Card';
export function MaterialApplicationSection() {
  const applications = [{
    icon: Car,
    title: 'Driveways',
    priority: 'Load Capacity + Wear Resistance',
    description: 'Must handle heavy vehicles, plow blades, and prevent rutting.',
    best: ['Concrete (Poured)', 'Interlock Pavers'],
    caution: ['Asphalt (shorter life)', 'Natural Stone (cost prohibitive)']
  }, {
    icon: Footprints,
    title: 'Walkways & Steps',
    priority: 'Slip Resistance + Safe Edges',
    description: 'Must be safe for winter boots and resist freeze-thaw heaving.',
    best: ['Concrete (Broom Finish)', 'Interlock Pavers'],
    caution: ['Natural Stone (can be slippery)', 'Smooth Concrete']
  }, {
    icon: TreePine,
    title: 'Patios',
    priority: 'Comfort + Aesthetics',
    description: 'Must be comfortable for bare feet and stable for furniture.',
    best: ['Interlock Pavers', 'Natural Stone', 'Stamped Concrete'],
    caution: ['Rough Broom Concrete (less comfortable)']
  }];
  return <section className="py-16 bg-slate-50 md:py-24" data-id="element-610">
      <div className="container mx-auto px-4 md:px-6" data-id="element-611">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-612">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-613">
            What Matters by Application
          </h2>
          <p className="mt-4 text-lg text-slate-600" data-id="element-614">
            The right material depends on how you use the space.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-615">
          {applications.map((app, index) => <Card key={index} className="border-slate-200 hover:border-primary/30 transition-colors" data-id="element-616">
              <CardHeader data-id="element-617">
                <div className="w-12 h-12 rounded-lg bg-white border border-slate-200 flex items-center justify-center mb-4 text-primary shadow-sm" data-id="element-618">
                  <app.icon className="h-6 w-6" data-id="element-619" />
                </div>
                <CardTitle className="text-xl" data-id="element-620">{app.title}</CardTitle>
                <div className="inline-block bg-primary/10 px-2 py-1 rounded text-xs font-bold text-primary mt-2" data-id="element-621">
                  Priority: {app.priority}
                </div>
              </CardHeader>
              <CardContent data-id="element-622">
                <p className="text-slate-600 mb-6 text-sm" data-id="element-623">{app.description}</p>

                <div className="space-y-4" data-id="element-624">
                  <div data-id="element-625">
                    <h4 className="text-sm font-bold text-green-700 mb-2 flex items-center gap-2" data-id="element-626">
                      <Check className="h-4 w-4" data-id="element-627" /> Best Materials:
                    </h4>
                    <ul className="space-y-1" data-id="element-628">
                      {app.best.map((item, i) => <li key={i} className="text-sm text-slate-600 pl-6 relative" data-id="element-629">
                          <span className="absolute left-2 top-2 w-1 h-1 rounded-full bg-slate-400" data-id="element-630"></span>
                          {item}
                        </li>)}
                    </ul>
                  </div>

                  <div data-id="element-631">
                    <h4 className="text-sm font-bold text-amber-700 mb-2 flex items-center gap-2" data-id="element-632">
                      <AlertTriangle className="h-4 w-4" data-id="element-633" /> Caution:
                    </h4>
                    <ul className="space-y-1" data-id="element-634">
                      {app.caution.map((item, i) => <li key={i} className="text-sm text-slate-600 pl-6 relative" data-id="element-635">
                          <span className="absolute left-2 top-2 w-1 h-1 rounded-full bg-slate-400" data-id="element-636"></span>
                          {item}
                        </li>)}
                    </ul>
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}